import { useState, type MutableRefObject } from "react";
import { ClipboardCopy } from "lucide-react";
import { Button } from "@mui/material";

interface TARSChartCopyImageToolbarProps {
  copyRef: MutableRefObject<(() => Promise<void>) | null>;
  /** Defaults to "Copy Chart". */
  buttonLabel?: string;
  /** Defaults to "Copy chart". */
  ariaLabel?: string;
}

export default function TARSChartCopyImageToolbar({
  copyRef,
  buttonLabel = "Copy Chart",
  ariaLabel = "Copy chart",
}: TARSChartCopyImageToolbarProps) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    const fn = copyRef.current;
    if (!fn || busy) return;
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      console.error("Copy chart image failed", e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outlined"
      size="small"
      disabled={busy}
      onClick={() => run()}
      aria-label={ariaLabel}
      startIcon={<ClipboardCopy size={16} strokeWidth={2} aria-hidden />}
      sx={{ textTransform: "none" }}
    >
      {buttonLabel}
    </Button>
  );
}
